import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { CartProvider } from './CartContext';
import BottomNav from './components/BottomNav';
import Menu from './pages/Menu';
import Cart from './pages/Cart';
import CheckoutPage from './pages/CheckoutPage';
import { setupBackButton, hideBackButton } from './utils/telegram';

// Profile Pages
import ProfileHome from './pages/Profile/ProfileHome';
import OrdersHistory from './pages/Profile/OrdersHistory';
import AddressesList from './pages/Profile/AddressesList';
import AddAddressPage from './pages/Profile/AddAddressPage';
import Invite from './pages/Profile/Invite';
import Info from './pages/Profile/Info';
import Documents from './pages/Profile/Documents';       
import DocumentViewer from './pages/Profile/DocumentViewer';

import AgreementGuard from './components/AgreementGuard';

/**
 * Logic: Auto-scroll to top on route change
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

/**
 * Logic: Управление нативной кнопкой BackButton в Telegram WebApp
 */
function TelegramNavigationHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/') {
      hideBackButton();
    } else {
      return setupBackButton(() => {
        navigate(-1);
      });
    }
  }, [location.pathname, navigate]);

  return null;
}

/**
 * @component App
 * @description Главный контейнер приложения с интеграцией Telegram WebApp API.
 */
function App() {
  const [isReady, setIsReady] = useState(false);
  const tg = window.Telegram?.WebApp;

  useEffect(() => {
    if (tg) {
      tg.ready();
      tg.expand();
      setIsReady(true);
    }
  }, [tg]);

  if (!isReady) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-900 text-white font-sans">
        <h1 className="text-2xl font-bold mb-4">Moyoo Bot</h1>
        <p className="opacity-70 text-sm italic">Загрузка...</p>
      </div>
    );
  }

  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <TelegramNavigationHandler />
        <div className="app-container font-sans text-tg-text bg-tg-bg min-h-screen selection:bg-tg-button/20">
          
          <AgreementGuard>
              <Routes>
                {/* Main Shop Routes */}
                <Route path="/" element={<Menu />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                
                {/* Profile & Loyalty Section */}
                <Route path="/profile" element={<ProfileHome />} />
                <Route path="/profile/orders" element={<OrdersHistory />} />
                <Route path="/profile/addresses" element={<AddressesList />} />
                <Route path="/profile/addresses/add" element={<AddAddressPage />} />
                <Route path="/profile/invite" element={<Invite />} />
                <Route path="/profile/info" element={<Info />} />
                
                {/* Legal & Docs */}
                <Route path="/profile/documents" element={<Documents />} />
                <Route path="/profile/documents/:id" element={<DocumentViewer />} />
              </Routes>
          </AgreementGuard>

          <BottomNav />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
